import styled from 'styled-components';

import { breakpoints } from '@/styles/breakpoint';

export const HelpContainer = styled.div`
  margin-top: 1.5rem;
  width: 23rem;
  ${breakpoints.combinedTablet} {
    margin-block: 1rem;
    width: 100%;
    margin-bottom: 0;
  }
`;

export const HelpLabelButtonWrapper = styled.div`
  padding: 1rem 0;

  &:last-child {
    padding-bottom: 0;
  }

  ${breakpoints.combinedTablet} {
    padding-bottom: 0;
  }
`;

export const HelpHeader = styled.span`
  font-size: ${(props) => props.theme.typography6.fontSize};
  font-weight: ${(props) => props.theme.typography6.fontWeight};
  text-align: ${(props) => props.theme.typography6.textAlign};
`;
